import useStore from "../../hooks/store/useStore";
import {
  clubAppStorageKey,
  webLoginStorageKey,
} from "../../constants/storage";
import { MarketType, SourceType } from "../../types";

let isHandlingExpired = false;

function build404Url(market: MarketType | null, source: SourceType): string {
  const params = new URLSearchParams({
    source,
    ...(market ? { market } : {}),
  });

  return `/404?${params}`;
}

export default function handleTokenExpired() {
  const market = useStore.getState().user.userInformation?.market ?? null;
  const source = useStore.getState().global.source;

  if (isHandlingExpired) return;

  isHandlingExpired = true;

  localStorage.removeItem(webLoginStorageKey);
  localStorage.removeItem(clubAppStorageKey);

  if (source === SourceType.ClubApp) {
    window.location.replace(build404Url(market, source));

    return;
  }

  useStore.getState().tokens.clearTokens();
  useStore.getState().user.clearUserInformation();
}
